import { db } from '../db.ts';

/**
 * Read-only views of the sync queue. The drainer that empties it arrives in
 * phase 12; the entry list needs to know now which records are stuck, so a
 * trainee is never falsely reassured that work is safe on the server when it is
 * not. That is hazard H2 in COMPLIANCE.md.
 */

export const outboxRepository = {
  /** Ids of records whose sync has failed repeatedly, for the row indicator. */
  async failedEntityIds(userId: string): Promise<Set<string>> {
    const failed = await db.outbox.where('status').equals('failed').toArray();

    return new Set(failed.filter((item) => item.userId === userId).map((item) => item.entityId));
  },

  async pendingCount(userId: string): Promise<number> {
    const pending = await db.outbox.where('status').equals('pending').toArray();
    return pending.filter((item) => item.userId === userId).length;
  },
};
